import * as React from "react";
import View from "../../views/Landing/FooterLanding.view";

import { COMPANY } from "../../constants/AppConstants";
interface IStateFooterLanding {
  emailText: string;
  telText: string;
}
declare let window;
class FooterLanding extends React.Component {
  state: IStateFooterLanding;

  constructor(props) {
    super(props);

    //@ts-ignore
    let telText = COMPANY.TEL;
    //@ts-ignore

    let emailText = COMPANY.EMAIL;
    this.state = {
      emailText: emailText,
      telText: telText
    };
  }

  render() {
    return <View emailText={this.state.emailText} telText={this.state.telText} />;
  }
}

export default FooterLanding;



// WEBPACK FOOTER //
// ./assets/react/components/Landing/FooterLanding.component.tsx